<template>
    <div>
        <iframe ref="editor" v-bind:style="currentStyle" :src="workspaceUrl+'/proxy/?tkn=yourTokenHere&workspace=/home/workspace/.vscode/project.code-workspace'"></iframe>
    </div>
</template>

<script>
import {eventBus, services} from "../../main";

export default {
    name: "EditorNG",
    mounted() {
        // when resizing the window the editor should also be resized
        this.resizeObserver = new ResizeObserver(() => {this.calculateStyle(); window.dispatchEvent(new Event('resize')); }).observe(this.$refs.editor);
        this.$nextTick(function () {
            window.addEventListener('resize', this.calculateStyle);
        });

        this.calculateStyle();

        const socket = services.workspace.getEventSocket(this.workspaceUrl)
        socket.on("connect", () => {
          eventBus.$emit("editorReady")
        });
        socket.on("DidChangeTextDocument", (data) => {
          if (!data.file.endsWith(this.filePath)) {
            console.log("Other file, skip")
            return
          }
          eventBus.$emit("editorChangedContent", {fileContent: data.content});
        })

        socket.on("DidManualSave", (data) => {
          if (!data.file.endsWith(this.filePath)) {
            console.log("Other file, skip")
            return
          }
          eventBus.$emit("runTests");
        })

        eventBus.$on("toggleTheme", (theme) => {
            socket.emit("toggleTheme", theme);
        });
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.unobserve(this.$refs.editor);
        }
    },
    destroyed() {

    },
    data() {
        return {
            rootUri: "file:///data/task-data",
            model: null,
            editor: null,
            webSocket: null,
            fatalError: false,
            editorLoaded: false,
            currentStyle: null,
            languageServerDiagnosticsInitialized: false,
            resizeObserver: {type: Object, default: null},
        }
    },
    props: {
        workspaceUrl: {type: String, default: null},
        programmingLanguage: {type: String,},
        code: {type: String},
        readOnly: {type: Boolean, default: false},
        minimap: {type: Boolean, default: true},
        filePath: {type: String, default: ''},
        theme: {type: String, default: 'vs-dark'},
        width: {type: [String, Number], default: '100%'},
        height: {type: [String, Number], default: undefined},
        additionalOptions: {
            type: Object, default: () => {
                return {
                    renderIndentGuides: true,
                }
            }
        }
    },
    methods: {
        convertRemToPixels(rem) {
            return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
        },
        calculateStyle() {
            const {width, height} = this;
            const fixedWidth = width.toString().indexOf('%') !== -1 ? width : `${width}px`;

            if (height && height != 0) {
                const fixedHeight = width.toString().indexOf('%') !== -1 ? height : `${height}px`;
                this.currentStyle = {
                    width: fixedWidth,
                    height: fixedHeight,
                    margin: "6px auto",
                    "box-sizing": "border-box"
                };
                return
            }

            // Get the window height browser independently
            let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            // remove the header bar

            let navbarHeight = 62;
            try {
                navbarHeight = document.getElementById('navbar_row').offsetHeight;
            } catch (err) {
                console.warn(err);
            }
            let heightOfConsoleOutput = this.convertRemToPixels(4);
            windowHeight = windowHeight - navbarHeight - 13 - heightOfConsoleOutput;

            const fixedHeight = `${windowHeight}px`;
            this.currentStyle = {
                width: fixedWidth,
                height: fixedHeight,
                margin: "6px auto",
                "box-sizing": "border-box"
            };
        },
    }
}
</script>


<style scoped>
iframe {
  border: 0;
}
</style>
